<script setup lang="ts">
import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import LanguageSelector from '@/components/LanguageSelector.vue';
import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';
import { useCheckoutAnalytics } from '@/composables/useCheckoutAnalytics';

const checkoutFlow = useCheckoutFlow();
const { trackCheckoutAppViewed } = useCheckoutAnalytics();
const { warehouseData } = useWarehouseInfo();
const { t } = useI18n();

const handleStartCheckout = () => {
  checkoutFlow.setNextStep(CheckoutFlowStep.ValidationPage);
};

onMounted(() => {
  trackCheckoutAppViewed();
});
</script>

<template>
  <div class="juno-i18n-exclude d-flex flex-column gap-6 px-4 my-auto">
    <div class="d-flex justify-start">
      <language-selector class="juno-welcome-language-select" />
    </div>
    <h1 class="d-flex flex-column gap-2">
      <span class="welcome">{{ t('welcomePage.greeting') }}</span>
      <span class="title globalseo-exclude">{{ warehouseData?.name }}</span>
    </h1>
    <p class="instructions">{{ t('welcomePage.instructions') }}</p>
    <v-btn
      block
      append-icon="mdi-arrow-right"
      color="primary"
      @click="handleStartCheckout"
      :disabled="!checkoutFlow.isStepValid(CheckoutFlowStep.WelcomePage)">
      {{ t('welcomePage.startButton') }}
    </v-btn>
  </div>
</template>

<style scoped>
.page {
  background-color: #fcfcfc;
}

.juno-welcome-language-select {
  max-width: 180px;
}

.welcome {
  font-size: 20px;
  font-weight: 400;
  line-height: 125%;
  color: #3c3c3c;
}

.title {
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
  color: #1e3036;
}

.instructions {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  color: #3c3c3c;
}
</style>
